(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oripa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.rc-oripa');
    if (!root) return;
    var overlay = document.getElementById('rc-oripa-overlay');
    var dataEl = document.getElementById('rc-oripa-data');
    var cfg = {};
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) {}

    var current = null; // { variantId, packId }

    function setText(sel, val) {
      var el = overlay.querySelector(sel);
      if (el) el.textContent = val;
    }

    function openOverlay(btn) {
      current = { variantId: btn.getAttribute('data-variant-id'), packId: btn.getAttribute('data-pack-id') };
      setText('[data-overlay-title]', btn.getAttribute('data-pack-title'));
      setText('[data-overlay-price]', btn.getAttribute('data-pack-price'));
      setText('[data-overlay-common]', btn.getAttribute('data-odds-common') + '%');
      setText('[data-overlay-mid]', btn.getAttribute('data-odds-mid') + '%');
      setText('[data-overlay-rare]', btn.getAttribute('data-odds-rare') + '%');
      setText('[data-overlay-chase]', btn.getAttribute('data-odds-chase') + '%');
      if (typeof overlay.showModal === 'function') overlay.showModal();
      else overlay.setAttribute('open', '');
    }

    function closeOverlay() {
      if (typeof overlay.close === 'function') overlay.close();
      else overlay.removeAttribute('open');
    }

    root.querySelectorAll('[data-pack-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openOverlay(btn); });
    });
    overlay.querySelectorAll('[data-pack-close]').forEach(function (btn) {
      btn.addEventListener('click', closeOverlay);
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });

    var cta = overlay.querySelector('[data-pack-checkout]');
    cta.addEventListener('click', function () {
      if (!current || !current.variantId) return;
      cta.classList.add('is-loading');
      cta.disabled = true;
      // Add the pack to the cart (with a non-revealing line-item property), then
      // hand off to the store's normal secure checkout.
      fetch(cfg.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(current.variantId),
            quantity: 1,
            properties: { 'Pack': current.packId || 'mystery-slab' }
          }]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = cfg.checkoutUrl || '/checkout';
      }).catch(function (err) {
        cta.classList.remove('is-loading');
        cta.disabled = false;
        console.error('Mystery Slabs add-to-cart failed:', err);
      });
    });

    // ── Pool preview: slow tier-label rotation ──
    // Progressive enhancement: the markup renders a static, readable tier list
    // on its own. Only when motion is allowed do we switch a pool to the
    // fade-rotation presentation. Never rotates under reduced motion.
    (function initPoolPreviews() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      root.querySelectorAll('[data-pool-preview]').forEach(function (pool) {
        var tiers = pool.querySelectorAll('[data-pool-tier]');
        if (tiers.length < 2) return; // one tier: nothing to rotate, leave static
        pool.classList.add('is-rotating');
        var i = 0;
        tiers[0].classList.add('is-active');
        setInterval(function () {
          tiers[i].classList.remove('is-active');           // fade current out
          var next = (i + 1) % tiers.length;
          setTimeout(function () { tiers[next].classList.add('is-active'); }, 600); // then fade next in
          i = next;
        }, 2600);
      });
    })();

    // ── Recently-opened ticker ──
    // Relative-time formatting runs always (it's text, not motion); the fade
    // rotation is motion-gated. Static markup already shows the most recent
    // event, so no-JS / reduced-motion users lose nothing.
    (function initTicker() {
      var feed = root.querySelector('[data-ticker]');
      if (!feed) return;

      function relTime(iso) {
        var s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
        if (s < 60) return 'just now';
        var m = Math.floor(s / 60); if (m < 60) return m + (m === 1 ? ' min ago' : ' mins ago');
        var h = Math.floor(m / 60); if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
        var d = Math.floor(h / 24); return d + (d === 1 ? ' day ago' : ' days ago');
      }
      feed.querySelectorAll('[data-ticker-at]').forEach(function (t) {
        var iso = t.getAttribute('data-ticker-at');
        if (iso) t.textContent = relTime(iso);
      });

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      var items = feed.querySelectorAll('[data-ticker-item]');
      if (items.length < 2) return; // one event: nothing to rotate, leave static
      feed.classList.add('is-rotating');
      var i = 0;
      items[0].classList.add('is-active');
      setInterval(function () {
        items[i].classList.remove('is-active');
        var next = (i + 1) % items.length;
        setTimeout(function () { items[next].classList.add('is-active'); }, 600);
        i = next;
      }, 3200);
    })();

    // ── Post-purchase confirmation state ──
    // Shown when the page is loaded with ?rc_confirmed=1 (optionally &pack= and
    // &order=). This is how the customer returns to a premium confirmation after
    // paying — the wiring that redirects here post-payment (Order-status
    // additional script, or a Thank-you checkout UI extension) is a flagged
    // human/deploy step; the screen itself is complete and previewable via the URL.
    (function showConfirmedFromParams() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('rc_confirmed') !== '1') return;
      var panel = document.getElementById('rc-oripa-confirmed');
      if (!panel) return;
      var pack = params.get('pack');
      var order = params.get('order');
      var packEl = panel.querySelector('[data-confirmed-pack]');
      var orderEl = panel.querySelector('[data-confirmed-order]');
      if (packEl && pack) packEl.textContent = pack;
      if (orderEl && order) orderEl.textContent = 'Order ' + order;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('.rc-featured__grid');
    var prev = document.querySelector('.rc-featured__nav--prev');
    var next = document.querySelector('.rc-featured__nav--next');
    if (!grid || !prev || !next) return;

    function updateButtons() {
      prev.disabled = grid.scrollLeft <= 1;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.offsetWidth - 1;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -grid.offsetWidth, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      grid.scrollBy({ left: grid.offsetWidth, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-giveaway-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-rc-bonus-form]');
    if (!form) return;
    event.preventDefault();
    const status = form.querySelector('.rc-hub__status');
    const data = Object.fromEntries(new FormData(form));
    try {
      const res = await fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: data.email,
          instagramHandle: data.instagramHandle,
          giveawayConsent: data.giveawayConsent === 'on',
          marketingConsent: data.marketingConsent === 'on',
        }),
      });
      if (res.ok) { status.textContent = form.dataset.success; form.reset(); }
      else status.textContent = res.status === 409 ? form.dataset.duplicate : form.dataset.error;
    } catch (error) {
      status.textContent = form.dataset.error;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-product-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.rc-slideshow').forEach(function (root) {
      var track = root.querySelector('.rc-slideshow__track');
      var prev = root.querySelector('.rc-slideshow__nav--prev');
      var next = root.querySelector('.rc-slideshow__nav--next');
      if (!track || !prev || !next) return;

      function updateButtons() {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.offsetWidth - 1;
      }

      function step(direction) {
        track.scrollBy({ left: direction * track.offsetWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () {
        step(-1);
      });

      next.addEventListener('click', function () {
        step(1);
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();

      // Desktop click-and-drag scrolling. Touch devices already get native swipe.
      var isDragging = false;
      var didDrag = false;
      var dragStartX = 0;
      var scrollStartLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDragging = true;
        didDrag = false;
        dragStartX = event.clientX;
        scrollStartLeft = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        var delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 4) didDrag = true;
        track.scrollLeft = scrollStartLeft - delta;
      });

      function stopDrag() {
        isDragging = false;
      }

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointerleave', stopDrag);

      track.addEventListener('click', function (event) {
        if (didDrag) {
          event.preventDefault();
          didDrag = false;
        }
      });

      // Optional desktop autoplay, paused on hover/touch and skipped for reduced-motion.
      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      if (!autoplayEnabled || reduceMotion) return;

      var autoplaySpeed = parseFloat(root.getAttribute('data-autoplay-speed')) || 4;
      var autoplayTimer = null;

      function playNext() {
        if (track.scrollLeft >= track.scrollWidth - track.offsetWidth - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          step(1);
        }
      }

      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = window.setInterval(playNext, autoplaySpeed * 1000);
      }

      function stopAutoplay() {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('touchstart', stopAutoplay, { passive: true });

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-your-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var form = root.querySelector('#SellCardsForm');
      var rowsContainer = root.querySelector('#SellCardsForm-rows');
      var rowTemplate = root.querySelector('#SellCardsForm-row-template');
      var addRowButton = root.querySelector('#SellCardsForm-add-row');
      var sealedRowsContainer = root.querySelector('#SellCardsForm-sealed-rows');
      var sealedRowTemplate = root.querySelector('#SellCardsForm-sealed-row-template');
      var addSealedRowButton = root.querySelector('#SellCardsForm-add-sealed-row');
      var submissionTypeInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="submission_type"]'));
      var submissionTypePanels = Array.prototype.slice.call(root.querySelectorAll('[data-submission-type-panel]'));
      var photosInput = root.querySelector('#SellCardsForm-photos-input');
      var photosButton = root.querySelector('#SellCardsForm-photos-button');
      var photosPreview = root.querySelector('#SellCardsForm-photos-preview');
      var alertBox = root.querySelector('#SellCardsForm-alert');
      var submitButton = root.querySelector('#SellCardsForm-submit');
      var successBox = root.querySelector('#SellCardsForm-success');
      var endpoint = root.dataset.workerEndpoint;
      var maxPhotos = parseInt(root.dataset.maxPhotos, 10) || 10;
      var selectedFiles = [];
      var submitLabelEl = submitButton.querySelector('.sell-cards__submit-label');
      var defaultSubmitLabel = submitLabelEl.textContent;

      function addRow() {
        var fragment = rowTemplate.content.cloneNode(true);
        rowsContainer.appendChild(fragment);
      }

      function removeRow(rowEl) {
        if (rowsContainer.children.length > 1) {
          rowEl.remove();
        } else {
          rowEl.querySelectorAll('input').forEach(function (input) {
            input.value = input.dataset.field === 'quantity' ? '1' : '';
          });
          rowEl.querySelector('select').value = '';
        }
      }

      function addSealedRow() {
        var fragment = sealedRowTemplate.content.cloneNode(true);
        sealedRowsContainer.appendChild(fragment);
      }

      function removeSealedRow(rowEl) {
        if (sealedRowsContainer.children.length > 1) {
          rowEl.remove();
        } else {
          rowEl.querySelectorAll('input').forEach(function (input) {
            input.value = input.dataset.field === 'quantity' ? '1' : '';
          });
          rowEl.querySelectorAll('select').forEach(function (select) {
            select.value = '';
          });
        }
      }

      function getSubmissionType() {
        var checked = submissionTypeInputs.filter(function (input) {
          return input.checked;
        })[0];
        return checked ? checked.value : 'individual';
      }

      function updateSubmissionTypePanels() {
        var type = getSubmissionType();
        submissionTypePanels.forEach(function (panel) {
          panel.hidden = panel.dataset.submissionTypePanel !== type;
        });
      }

      function renderPhotoPreviews() {
        photosPreview.innerHTML = '';
        selectedFiles.forEach(function (file, index) {
          var thumb = document.createElement('div');
          thumb.className = 'sell-cards__photo-thumb';

          var img = document.createElement('img');
          img.src = URL.createObjectURL(file);
          img.alt = file.name;
          thumb.appendChild(img);

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'sell-cards__photo-remove';
          removeBtn.setAttribute('aria-label', root.dataset.removePhotoLabel);
          var removeBtnIcon = document.createElement('span');
          removeBtnIcon.className = 'sell-cards__photo-remove-icon';
          removeBtnIcon.setAttribute('aria-hidden', 'true');
          removeBtnIcon.textContent = '×';
          removeBtn.appendChild(removeBtnIcon);
          removeBtn.addEventListener('click', function () {
            selectedFiles.splice(index, 1);
            renderPhotoPreviews();
          });
          thumb.appendChild(removeBtn);

          photosPreview.appendChild(thumb);
        });
      }

      function showAlert(message) {
        alertBox.textContent = message;
        alertBox.hidden = false;
      }

      function hideAlert() {
        alertBox.hidden = true;
        alertBox.textContent = '';
      }

      function collectCardDetails() {
        var rows = rowsContainer.querySelectorAll('.sell-cards__row');
        var details = [];
        rows.forEach(function (row) {
          var name = row.querySelector('[data-field="name"]').value.trim();
          var set = row.querySelector('[data-field="set"]').value.trim();
          var condition = row.querySelector('[data-field="condition"]').value;
          var quantity = row.querySelector('[data-field="quantity"]').value;
          if (name || set) {
            details.push({ name: name, set: set, condition: condition, quantity: quantity || '1' });
          }
        });
        return details;
      }

      function collectSealedDetails() {
        var rows = sealedRowsContainer.querySelectorAll('.sell-cards__row');
        var details = [];
        rows.forEach(function (row) {
          var productType = row.querySelector('[data-field="product_type"]').value;
          var set = row.querySelector('[data-field="set"]').value.trim();
          var language = row.querySelector('[data-field="language"]').value.trim();
          var quantity = row.querySelector('[data-field="quantity"]').value;
          var condition = row.querySelector('[data-field="condition"]').value;
          if (productType || set) {
            details.push({
              productType: productType,
              set: set,
              language: language,
              quantity: quantity || '1',
              condition: condition,
            });
          }
        });
        return details;
      }

      addRow();
      addSealedRow();
      updateSubmissionTypePanels();

      addRowButton.addEventListener('click', addRow);
      addSealedRowButton.addEventListener('click', addSealedRow);

      submissionTypeInputs.forEach(function (input) {
        input.addEventListener('change', updateSubmissionTypePanels);
      });

      rowsContainer.addEventListener('click', function (event) {
        var button = event.target.closest('[data-action="remove-row"]');
        if (button) {
          removeRow(button.closest('.sell-cards__row'));
        }
      });

      sealedRowsContainer.addEventListener('click', function (event) {
        var button = event.target.closest('[data-action="remove-sealed-row"]');
        if (button) {
          removeSealedRow(button.closest('.sell-cards__row'));
        }
      });

      photosButton.addEventListener('click', function () {
        photosInput.click();
      });

      photosInput.addEventListener('change', function () {
        var incoming = Array.prototype.slice.call(photosInput.files);
        incoming.forEach(function (file) {
          if (selectedFiles.length < maxPhotos) {
            selectedFiles.push(file);
          }
        });
        photosInput.value = '';
        renderPhotoPreviews();
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideAlert();

        var fullName = form.full_name.value.trim();
        var email = form.email.value.trim();
        var submissionType = getSubmissionType();
        var cardDetails = submissionType === 'individual' ? collectCardDetails() : [];
        var sealedDetails = submissionType === 'sealed' ? collectSealedDetails() : [];

        if (!fullName || !email) {
          showAlert(root.dataset.errorNameEmail);
          return;
        }

        if (submissionType === 'individual' && cardDetails.length === 0) {
          showAlert(root.dataset.errorCards);
          return;
        }

        if (submissionType === 'sealed' && sealedDetails.length === 0) {
          showAlert(root.dataset.errorSealedItems);
          return;
        }

        if (selectedFiles.length === 0) {
          showAlert(root.dataset.errorPhotos);
          return;
        }

        if (!endpoint) {
          showAlert(root.dataset.errorUnavailable);
          return;
        }

        var formData = new FormData();
        formData.append('full_name', fullName);
        formData.append('email', email);
        formData.append('notes', form.notes.value.trim());
        formData.append('submission_type', submissionType);
        if (submissionType === 'individual') {
          formData.append('card_details', JSON.stringify(cardDetails));
        } else {
          formData.append('sealed_details', JSON.stringify(sealedDetails));
        }
        selectedFiles.forEach(function (file) {
          formData.append('photos', file, file.name);
        });

        submitButton.disabled = true;
        submitLabelEl.textContent = root.dataset.submittingLabel;

        fetch(endpoint, { method: 'POST', body: formData })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Request failed');
            }
            form.hidden = true;
            successBox.hidden = false;
            successBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
          })
          .catch(function () {
            showAlert(root.dataset.errorNetwork);
            submitButton.disabled = false;
            submitLabelEl.textContent = defaultSubmitLabel;
          });
      });
    }

    var root = document.getElementById('SellCardsForm-root');
    if (root) {
      init(root);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
